import actionTypes from './actionTypes';
import SharedSource from '../../sources/shared';
import { addNotification } from './notification';

export const setTypes = types => ({
    type: actionTypes.SET_TYPES,
    payload: types,
});

export const loadedTypes = () => ({
    type: actionTypes.LOADED_TYPES,
    payload: null,
});

export const loadingTypes = () => ({
    type: actionTypes.LOADING_TYPES,
    payload: null,
});

export const fetchTypes = (elementType, tenantId, authenticationToken) => async (dispatch) => {

    dispatch(loadingTypes());
    try {
        const types = await SharedSource.getAll(elementType, tenantId, authenticationToken);
        const parsedTypes = JSON.parse(types);
        dispatch(setTypes(parsedTypes));
    } catch (error) {
        dispatch(addNotification({
            type: 'error',
            message: error.message,
            isPersistent: true,
        }));
        dispatch(loadedTypes());
    }
};
